﻿import React from 'react';

import styled from 'styled-components';
import {connect} from 'react-redux';

import Feedback, { FeedbackSection } from '../Components/Feedback';

import {GuideFormBase, connectForm} from './GuideFormBase';
import NumberInput from '../../../Forms/Components/NumberInput';

import definitions from '../../../Style/LfStyleDefinitions';
import {required} from '../../../Forms/Validation/rules';
import getFormValues from '../../../Forms/getFormValues';

import {monthlySalaryExchangeMinimum} from '../Services/PensionCalculationService';

class Step3Form extends GuideFormBase {
    constructor(props) {
        super(props);
        this.feedbackDelay = 1500;
    }

    submitSection(e) {
        super.submitSection(e);
        const formValues = getFormValues(this.form);
        this.props.updateFormData({ wantedMonthlyPension: formValues.monthlySalary * 0.75 });
    }

    render() {
        const StepForm = this.stepFormWrapper;
        const formData = this.props.formData;
        const NavigationButtons = this.navigationButtons;

        const minSalary = 10000;

        const monthlySalarybelowMinAndEmployed = formData.monthlySalary > 0 && formData.monthlySalary < minSalary && formData.occupation == 'employed'
        const monthlySalaryAboveMinAndEmployed = formData.monthlySalary > minSalary && formData.occupation == 'employed'
        const monthlySalaryAboveZeroAndStudent = formData.monthlySalary > 0 && formData.occupation == 'student'
        const monthlySalaryAboveExchangeMinimum = formData.monthlySalary > monthlySalaryExchangeMinimum

        const showFeedback = monthlySalarybelowMinAndEmployed || monthlySalaryAboveMinAndEmployed || monthlySalaryAboveZeroAndStudent || monthlySalaryAboveExchangeMinimum;

        const targetSavings = (Math.floor(parseFloat(formData.monthlySalary) / 100) * 100)*0.04;

        return (
            <StepForm heading="Månadsinkomst (före skatt)">
                <NumberInput
                    theme="big"
                    id="monthlySalary"
                    name="monthlySalary"
                    innerLabel="kr"
                    padding="small"
                    min="1"
                    data-validation-error-message="Ange din inkomst"
                    validations={[required]}
                    placeholder="0"
                    value={formData.monthlySalary}
                />

                <NavigationButtons />

                <Feedback
                    condition={() => showFeedback}
                    showDelay={this.feedbackDelay}
                >
                    <div>
                        <img src="https://www.lararforsakringar.se/globalassets/forsakringar/bilderillustrationer/illustrationer/soff-bord.svg" alt="" />

                        {monthlySalarybelowMinAndEmployed && 
                        <FeedbackSection>
                            <h3 class="h4">Det viktiga egna sparandet</h3>
                            <p>
                                För bäst resultat i guiden så behöver vi utgå från en lön på minst 10 000 kronor per månad.
                            </p>
                            <p>
                                Om du exempelvis arbetar deltid så är det ur pensionssynpunkt bra att arbeta så mycket som du har möjlighet
                                till även om vi förstår att det inte alltid går. Även att höja din lön och att pensionsspara så mycket
                                du har möjlighet till är rekommenderat.
                            </p>
                        </FeedbackSection>}

                        {monthlySalaryAboveMinAndEmployed && 
                        <FeedbackSection>
                            <h3 class="h4">Det viktiga egna sparandet</h3>
                            <p>
                                Det är viktigt att komma igång att pensionsspara själv. Även små belopp blir på lång sikt stora.
                                Men ju närmare pensionen du är, desto mer behöver du spara själv, om du inte gjort det sedan tidigare.
                            </p>
                            <p>
                                Ett allmänt tips brukar vara att åtminstone spara 4% av sin bruttolön (det du får före skatt).
                            </p>
                            <p>
                                För dig skulle detta innebära: <HighlightedValue>{targetSavings} kr/månad</HighlightedValue>
                            </p>
                        </FeedbackSection>}

                        {monthlySalaryAboveZeroAndStudent && 
                        <FeedbackSection>
                            <h3 class="h4">Det viktiga egna sparandet</h3>
                            <p>
                                Det är viktigt att komma igång att pensionsspara själv. Som student kan det vara svårt att hitta utrymme, men
                                tänk på att även små belopp på lång sikt blir stora!
                            </p>
                            <p>
                                Ju närmare pensionen du är, desto mer behöver du spara själv, om du inte gjort det sedan tidigare.
                                Ett allmänt tips brukar vara att åtminstone spara 4% av sin månadsinkomst (före skatt).
                            </p>
                            <p>
                                För dig skulle detta innebära: <HighlightedValue>{targetSavings} kr/månad</HighlightedValue>
                            </p>
                        </FeedbackSection>}

                        {monthlySalaryAboveExchangeMinimum && 
                        <FeedbackSection>
                            <h3 class="h4">Löneväxling kanske kan vara något för dig</h3>
                            <p>
                                För dig som tjänar över ca {monthlySalaryExchangeMinimum} kronor och högre kan det vara en idé att genomföra en så kallad löneväxling.
                            </p>
                            <p>
                                Det innebär att du avstår en del av din lön på lönedelar över {monthlySalaryExchangeMinimum} kr (2019) för att istället få ytterligare
                                pensionsinsättningar av din arbetsgivare. Det innebär att du får en lägre skatt idag och genom pensionsavsättningarna
                                skjuter upp den löneökningen till den dagen du får pension.
                            </p>
                        </FeedbackSection>}
                    </div>
                </Feedback>

                <NavigationButtons mobileOnly={true} />
            </StepForm>
        );
    }
}

const HighlightedValue = styled.span`
    font-weight: bold;
    font-size: 22px;
    font-weight: bold;
    line-height: 31px;
`;

export default connectForm(Step3Form);
